/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */

// Material Dashboard 2 React - Tables Page with Filters
import Grid from "@mui/material/Grid";
import { Autocomplete, Box, Card, Chip, FormControl, InputLabel, MenuItem, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// React
import { useEffect, useState } from "react";
import persistedExpensesDataTable from "layouts/tables/data/persistedExpensesDataTable";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import mattersTableData from "layouts/tables/data/mattersTableData";
import dayjs from "dayjs";
import { addExpense, deleteExpense } from "apis/api";
import { getGroups } from "apis/api";
import { deleteGroup } from "apis/api";
import activitiesTableData from "layouts/tables/data/activitiesDataTable";
import { editGroup } from "apis/api";
const formatDate = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : null);
function Groupes() {
    const [activityKeyedData, setactivityKeyedData] = useState([]);
    const [persistedExpensesColumns, setPersistedExpensesColumns] = useState([]);
    const [persistedExpensesRows, setpersistedExpensesRows] = useState([]);
    const [loadingpersistedExpenses, setLoadingpersistedExpenses] = useState(false);
    const [mattersRows, setMattersRows] = useState([]);
    const [loadingMatters, setLoadingMatters] = useState(false);
    const [attorneys, setAttorneys] = useState(undefined);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [groupToDelete, setGroupToDelete] = useState({});
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);

    const [columns, setColumns] = useState([
        { Header: "Name", accessor: "id", align: "center" },
        {
            Header: "Numbers",
            accessor: "attorneys", // keep accessor simple
            align: "center",
            Cell: ({ value }) => value?.length ?? 0, // display number of attorneys
        },
        {
            Header: "Actions",
            accessor: "actions",
            align: "center",
            Cell: ({ row }) => (
                <>
                    <Button
                        variant="contained"
                        color="info"
                        size="small"
                        onClick={() => handleEditClick(row.original)}
                        sx={{ mr: 1 }}
                    >
                        Edit
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: 'red !important',
                            color: 'white !important',
                            '&:hover': { backgroundColor: '#cc0000 !important' }
                        }}
                        size="small"
                        onClick={() => handleDeleteClick(row.original)}
                    >
                        Delete
                    </Button>
                </>
            ),
        },
    ]);
    const [newGroup, setNewGroup] = useState({
        id: "",
        attorneys: [],
    });

    const loadMattersData = async () => {
        setLoadingMatters(true);
        const { mattersColumns, mattersRows, mattersData } = await mattersTableData({
            issuedAfter: formatDate(dayjs("2025-01-01")),
            issuedBefore: formatDate(dayjs()),
        });

        //setMattersColumns(mattersColumns);
        //setMattersRows(mattersRows);

        setLoadingMatters(false);
        // let cleanedData = mattersData.data.filter(
        //     (item) => item && item.state !== "void" && item.state !== "deleted"
        // );
        // cleanedData = mattersData.data.filter(
        //     (item) =>
        //         item &&
        //         item.state !== "void" &&
        //         item.state !== "deleted" &&
        //         item.originating_attorney !== null
        // );
        setMattersRows(mattersRows);
    };

    const loadPersistedExpensesData = async () => {
        setLoadingpersistedExpenses(true);
        const { persistedExpensesColumns, persistedExpensesRows, persistedExpensesData } =
            await persistedExpensesDataTable();


        setPersistedExpensesColumns(persistedExpensesColumns.filter(item =>
            ["date", "AttorneyDirectExpenses", "TotalGeneralExpenses"].includes(item.accessor)
        ));

        setpersistedExpensesRows(persistedExpensesData);
        setPersistedExpensesColumns((prevCols) => [
            ...prevCols,
            {
                Header: "Actions",
                accessor: "actions",
                align: "center",
                Cell: ({ row }) => (
                    <Button
                        variant="contained"
                        onClick={() => handleDeleteClick(row.original)}
                        size="small"
                        sx={{
                            backgroundColor: 'red !important',
                            color: 'white !important',
                        }}
                    >
                        Delete
                    </Button>
                ),
            },
        ]);
        setLoadingpersistedExpenses(false);
    };
    const loadActivitiesData = async () => {

        const { activitiesColumns, activitiesRows, activitiesData } = await activitiesTableData({
            issuedAfter: formatDate(dayjs("2025-01-01")),
            issuedBefore: formatDate(dayjs()),
        });

        let cleanedData = activitiesData.data.filter(
            (item) => item && item.state !== "void" && item.state !== "deleted"
        );

        const activityKeyedData = {};
        const activityAttorneyMatter = {};

        // Create more comprehensive invalid activities tracking
        const invalidActivitiesByAttorney = {};
        const unassignedActivities = []; // For data without attorney info

        // First, process ALL activities and check for data issues
        activitiesData.data.forEach((item, index) => {
            try {
                // Skip if item is null or undefined
                if (!item) {
                    unassignedActivities.push({
                        _errorReason: "Null or undefined activity",
                        _index: index,
                    });
                    return;
                }

                // Step 1: Check for all required fields but only flag errors for matter issues
                const hasBill = item.bill && typeof item.bill === "object";
                const hasUser = item.user && typeof item.user === "object" && item.user.name;
                const hasMatter = item.matter && typeof item.matter === "object";
                const hasDisplayNumber = hasMatter && item.matter.display_number;

                // Only check for matter-related errors
                let errorReason = null;
                if (!hasMatter) errorReason = "Missing matter object";
                else if (!hasDisplayNumber) errorReason = "Missing display_number";

                if (errorReason) {
                    // This is an invalid activity - classify by attorney if possible
                    if (hasUser) {
                        const attorneyName = item.user.name;
                        if (!invalidActivitiesByAttorney[attorneyName]) {
                            invalidActivitiesByAttorney[attorneyName] = [];
                        }
                        invalidActivitiesByAttorney[attorneyName].push({
                            ...item,
                            _errorReason: errorReason,
                            _index: index,
                        });
                    } else {
                        // No attorney information - save separately
                        unassignedActivities.push({
                            ...item,
                            _errorReason: errorReason,
                            _index: index,
                        });
                    }

                    // For items with issues, don't process further
                    return;
                }

                // Process valid activities for reporting (only if they have bill and user)
                if (hasBill && hasUser) {
                    // Step 2: Process key data for reporting
                    if (item.bill.number in activityKeyedData) {
                        if (item.user.name in activityKeyedData[item.bill.number]) {
                            activityKeyedData[item.bill.number][item.user.name] += item.total || 0;
                        } else {
                            activityKeyedData[item.bill.number][item.user.name] = item.total || 0;
                        }
                    } else {
                        activityKeyedData[item.bill.number] = {
                            [item.user.name]: item.total || 0,
                        };
                    }

                    // Step 3: Process matter tracking (only for valid activities)
                    if (item.total && hasDisplayNumber) {
                        if (item.user.name in activityAttorneyMatter) {
                            activityAttorneyMatter[item.user.name].add(item.matter.display_number);
                        } else {
                            activityAttorneyMatter[item.user.name] = new Set([item.matter.display_number]);
                        }
                    }
                }
            } catch (error) {
                console.error(`Error processing activity at index ${index}:`, error);

                // Add to unassigned errors if we can't process it
                unassignedActivities.push({
                    ...item,
                    _errorReason: `Processing error: ${error.message}`,
                    _index: index,
                });
            }
        });

        setactivityKeyedData(activityKeyedData);


    };
    const loadGroupes = async () => {
        const ret = await getGroups();
        const groups = JSON.parse(ret.body);


        setGroups(groups);
    }

    const handleDeleteClick = (e) => {
        setGroupToDelete(e);
        setDeleteDialogOpen(true);

    };


    const confirmDelete = async () => {


        setDeleteDialogOpen(false);
        setGroupToDelete(null);

        await deleteGroup(groupToDelete.id);
        loadGroupes();
    };
    const handleEditClick = (e) => {
        setGroupToDelete(e);
        setSelectedGroup(e.attorneys);

        setEditDialogOpen(true);
    };
    const confirmeEdit = async () => {
        await editGroup({
            "id": groupToDelete.id,
            "attorneys": selectedGroup
        });
        setEditDialogOpen(false);
        setGroupToDelete(null);
        setSelectedGroup([]);
        loadGroupes();

    }
    const confirmAdd = async () => {
        await editGroup(newGroup);
        setOpenAddDialog(false);
        setNewGroup({ id: "", attorneys: [] });
        loadGroupes();

    }

    useEffect(() => {
        loadPersistedExpensesData();
        loadMattersData();
        loadGroupes();
        loadActivitiesData();
    }, []);
    //loadAttoerneys;
    useEffect(() => {
        if (mattersRows && persistedExpensesRows && activityKeyedData) {

            const originating = mattersRows.map(
                (item) => item.originating_attorney_name
            );
            const responsible = mattersRows.map(
                (item) => item.responsible_attorney_name
            );

            const actionAttorneysSet = new Set();

            Object.values(activityKeyedData).forEach((item) => {
                Object.keys(item).forEach((attorney) => {
                    actionAttorneysSet.add(attorney);
                });
            });

            const expenses = persistedExpensesRows.map(
                (item) => item["attorney"]
            );
            const newattorneys = []
                .concat(originating)
                .concat(responsible)
                .concat(Array.from(actionAttorneysSet))
                .concat(expenses)
                .filter((item) => item !== "");
            const distinctAttorney = Array.from(new Set(newattorneys));

            setAttorneys(distinctAttorney);
        }
    }, [mattersRows, persistedExpensesRows, activityKeyedData]);


    const inputStyle = {
        width: 250,
        backgroundColor: "white",
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={3} pb={3}>
                {/*delete popUp */}
                <Dialog
                    open={deleteDialogOpen}
                    onClose={() => setDeleteDialogOpen(false)}
                >
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                        Are you sure you want to delete this Group?
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                        <Button
                            onClick={confirmDelete}
                            variant="contained"
                            sx={{
                                backgroundColor: 'red !important',
                                color: 'white !important',
                                '&:hover': {
                                    backgroundColor: '#cc0000', // darker red on hover
                                },
                                '&:focus': {
                                    backgroundColor: '#cc0000',
                                },
                            }}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* edit popup */}
                <Dialog
                    open={editDialogOpen}
                    onClose={() => setEditDialogOpen(false)}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>Edit Group</DialogTitle>

                    <DialogContent>
                        <Stack spacing={3} mt={1}>
                            <TextField
                                label="Group Name"
                                fullWidth
                                value={groupToDelete?.id}
                                onChange={(e) => setGroupToDelete({ ...prev, id: e.target.value })}
                            />

                            <Autocomplete
                                multiple
                                options={attorneys}
                                getOptionLabel={(option) => option}
                                value={selectedGroup}
                                onChange={(event, newValue) => {
                                    setSelectedGroup(newValue);
                                }}
                                renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => (
                                        <Chip key={option} label={option} {...getTagProps({ index })} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Attorneys" />
                                )}
                                sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "8px",
                                    "& .MuiInputBase-root": {
                                        padding: "6px",
                                    },
                                    "& .MuiChip-root": {
                                        margin: "2px",
                                    },
                                }}
                            />
                        </Stack>
                    </DialogContent>

                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
                        <Button
                            onClick={confirmeEdit}
                            variant="contained"
                            color="error"
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#cc0000',
                                },
                            }}
                        >
                            Edit
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* add Group */}
                <Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)} fullWidth
                    maxWidth="md">
                    <DialogTitle>Add New Group</DialogTitle>


                    <DialogContent>
                        <Stack spacing={3} mt={1}>
                            <TextField
                                label="Group Name"
                                fullWidth
                                value={newGroup?.id}
                                onChange={(e) => setNewGroup((prev) => ({
                                    ...prev,
                                    id: e.target.value
                                }))}
                            />

                            <Autocomplete
                                multiple
                                options={attorneys}
                                getOptionLabel={(option) => option}
                                value={newGroup?.attorneys}
                                onChange={(event, newValue) => {
                                    setNewGroup((prev) => ({
                                        ...prev,
                                        attorneys: newValue
                                    }));
                                }}
                                renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => (
                                        <Chip key={option} label={option} {...getTagProps({ index })} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Attorneys" />
                                )}
                                sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "8px",
                                    "& .MuiInputBase-root": {
                                        padding: "6px",
                                    },
                                    "& .MuiChip-root": {
                                        margin: "2px",
                                    },
                                }}
                            />
                        </Stack>
                    </DialogContent>

                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
                        <Button
                            onClick={confirmAdd}
                            variant="contained"
                            color="error"
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#cc0000',
                                },
                            }}
                        >
                            Add New
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ position: "relative", minHeight: 100 }}
                >



                    {/* <Grid item sx={{ top: 0, zIndex: 0 }}>
                        <TextField
                            label="Month"
                            type="month"
                            defaultValue="2025-07"
                            InputLabelProps={{ shrink: true }}
                            sx={inputStyle}
                        />
                    </Grid> */}
                    <MDBox display="flex" justifyContent="flex-end" >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenAddDialog(true)}
                            sx={{
                                backgroundColor: "#1976d2",
                                color: "#fff !important",

                            }}
                        >
                            Add New Group
                        </Button>
                    </MDBox>





                </Grid>
                <Grid item xs={12}>
                    <Card>
                        {!loadingpersistedExpenses && loadMattersData && (
                            <>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >

                                    <MDTypography variant="h6" color="white">
                                        Groups
                                    </MDTypography>
                                </MDBox>

                                <MDBox>
                                    <DataTable
                                        table={{ columns: columns, rows: groups }}
                                        isSorted={true}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                </MDBox>

                            </>

                        )}
                    </Card>
                </Grid>
            </MDBox>

        </DashboardLayout>
    );
}

export default Groupes;